import SuccessIcon from 'components/Icons/SuccessIcon';
import { useHistoryBatch } from 'contexts/HistoryBatch';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const Processing = () => {
  const { refresh } = useHistoryBatch();

  const { t } = useTranslation(['history', 'beneficiaries']);

  return (
    <div className="processing-wrapper">
      <SuccessIcon />
      <span>{t('follow_up')}</span>
      <span>{t('follow_up_text')}</span>
      <div className="button-container">
        <button type="button" className="reimport-button" onClick={refresh}>
          {t('refresh_page')}
        </button>
      </div>
    </div>
  );
};
